import React, { useState, useEffect } from "react";
import { useTranslation } from 'react-i18next';
import {
    Box,
    Container,
    Typography,
    Grid,
    Paper,
    Button,
    Card,
    CardContent,
    Accordion,
    AccordionSummary,
    AccordionDetails,
    Divider,
    Chip,
    List,
    ListItem,
    ListItemIcon,
    ListItemText,
} from "@mui/material";
import {
    ExpandMore as ExpandMoreIcon,
    CheckCircle,
    Psychology,
    Speed,
    Savings,
    Accessibility,
    ChildCare,
    EmojiEmotions,
    Lightbulb,
    DirectionsRun,
    Create,
    MenuBook,
    Hearing,
    RecordVoiceOver,
    Sensors,
} from "@mui/icons-material";
import { Link } from "react-router-dom";
import Popup from "reactjs-popup";
import "reactjs-popup/dist/index.css";
import NL1HubApp from '../components/AboutPage/images/NL1Hub App.png';

function Product() {
    const { t } = useTranslation();
    const [learnMore, setLearnMore] = useState(false);
    const [isLoggedIn, setIsLoggedIn] = useState(false);

    useEffect(() => {
        if (localStorage.getItem('AUTHORIZATION_TOKEN_BLOG')) {
            setIsLoggedIn(true);
        }
    }, []);

    const featuresRaw = t('ProductsPage.WhyChoose.Features', { returnObjects: true });
    const features = Array.isArray(featuresRaw) ? featuresRaw : [];
    const featureIcons = [
       <Psychology sx={{ fontSize: 40 }} />,
       <Savings sx={{ fontSize: 40 }} />,
       <Speed sx={{ fontSize: 40 }} />,
       <ChildCare sx={{ fontSize: 40 }} />,
       <Accessibility sx={{ fontSize: 40 }} />,
       <Lightbulb sx={{ fontSize: 40 }} />,
   ];
    const featuresWithIcons = features.map((f, i) => ({ ...f, icon: featureIcons[i] }));
    const areasCoveredRaw = t('ProductsPage.AreasCoveredList', { returnObjects: true });
    const areasCoveredList = Array.isArray(areasCoveredRaw) ? areasCoveredRaw : [];

    const multiSymptomPointsRaw = t('ProductsPage.MultiSymptomPoints', { returnObjects: true });
    const multiSymptomPoints = Array.isArray(multiSymptomPointsRaw) ? multiSymptomPointsRaw : [];

    const challengesPointsRaw = t('ProductsPage.ChallengesPoints', { returnObjects: true });
    const challengesPoints = Array.isArray(challengesPointsRaw) ? challengesPointsRaw : [];
    const getArray = (key) => {
        const data = t(`ProductsPage.${key}`, { returnObjects: true });
        return Array.isArray(data) ? data : [];
    };

    const stats = getArray('StatsList');
    const cognitiveSkills = getArray('CognitiveSkills');
    const interpersonalSkills = getArray('InterpersonalSkills');
    const identifiableEmotions = getArray('IdentifiableEmotions');
    const grossMotorSkills = getArray('GrossMotorSkills');
    const fineMotorSkills = getArray('FineMotorSkills');
    const readingSkills = getArray('ReadingSkills');
    const writingSkills = getArray('WritingSkills');
    const receptiveLanguage = getArray('ReceptiveLanguage');
    const expressiveLanguage = getArray('ExpressiveLanguage');
    const technologyIntegration = getArray('TechnologyIntegration');

    // Extract Popup object safely
    const popupContent = t('ProductsPage.PopupContent', { returnObjects: true }) || {};
    // Ensure popupContent doesn't crash if empty during load
    if (!popupContent.screening) {
        popupContent.screening = { title: '', content: '' };
        popupContent.assessment = { title: '', content: '' };
        popupContent.intervention = { title: '', content: '' };
    }

    // const interpersonalSkills = [
    //     {
    //         title: "Motivation",
    //         description: "Consists of doing what you enjoy, working towards achieving goals, and not being motivated by money or status"
    //     },
    //     {
    //         title: "Social Skills",
    //         description: "Effective at managing relationships that benefits everyone involved (ex: confidence, communication, cooperation)"
    //     },
    //     {
    //         title: "Empathy",
    //         description: "Able to identify and understand other's emotions"
    //     },
    //     {
    //         title: "Self Awareness",
    //         description: "The ability to recognize your own emotions, strengths, and limitations, and their impact on others around you"
    //     },
    //     {
    //         title: "Self Regulation",
    //         description: "Allows you to wisely manage your emotions and impulses"
    //     }
    // ];

    // const identifiableEmotions = [
    //     {
    //         title: "Trust",
    //         description: "Assured reliance on the character, ability, strength, or truth of someone or something"
    //     },
    //     {
    //         title: "Happiness",
    //         description: "An emotional state characterized by feelings of joy, satisfaction contentment, and fullfillment"
    //     },
    //     {
    //         title: "Relation to Self",
    //         description: "Emotional stimuli attract attention because of their high motivational relevance for the observer's wellbeing and survival"
    //     },
    //     {
    //         title: "Anger",
    //         description: "An emotion characterized by antagonism toward someone or something you feel has deliberately done you wrong"
    //     },
    //     {
    //         title: "Stress",
    //         description: "A state of mental or emotional strain or tension resulting from adverse or very demanding circumstances"
    //     },
    //     {
    //         title: "Jealousy",
    //         description: "Thoughts or feelings of insecurity, fear, and concern over a relative lack of possessions or safety"
    //     }
    // ];

    // const grossMotorSkills = [
    //     {
    //         title: "Reflexes",
    //         items: ["Newborn Reflexes", "Reactions", "Motor reflex (patellar reflex)"]
    //     },
    //     {
    //         title: "Stationary",
    //         items: ["Head/trunk", "Sitting and standing"]
    //     },
    //     {
    //         title: "Movements",
    //         items: ["Basic exercises", "Range of motion"]
    //     },
    //     {
    //         title: "Locomotion",
    //         items: ["Leg movement", "Turning movement", "Arm movement", "Crawling, Walking, Running", "Standing and Jumping", "Rolling"]
    //     }
    // ];

    // const fineMotorSkills = [
    //     {
    //         title: "Visual motor integration",
    //         items: ["Paper manipulation", "Cube/pellet manipulation", "Tracking objects"]
    //     },
    //     {
    //         title: "Grasping",
    //         items: ["Touching", "Grab & release", "Shaking, pulling", "Writing/drawing", "Cutting paper"],
    //         subSection: {
    //             title: "Self care tasks",
    //             items: ["Buttoning", "Tying/untying shoes", "Utensil manipulation"]
    //         }
    //     }
    // ];

    // const readingSkills = [
    //     {
    //         title: "Word Construction",
    //         items: [
    //             "Ability to divide words into syllables for written words",
    //             "Ability to count syllables in words read orally",
    //             "Adding prefixes to words (Adv.)",
    //             "Adding suffixes to words (Adv.)"
    //         ]
    //     },
    //     {
    //         title: "Word Detection & Pattern Recognition",
    //         items: [
    //             "Ability to listen to words orally and name the beginning sounds",
    //             "Ability to recognize and pronounce beginning consonants when presented with a list of on a computer screen",
    //             "Ability to recognize beginning consonants when presented"
    //         ]
    //     },
    //     {
    //         title: "Letter Recognition",
    //         items: ["Lowercase Letters", "Uppercase Letters"]
    //     },
    //     {
    //         title: "Speaking & Sounding Out",
    //         items: [
    //             "Ability to pronounce final consonants in spoken words",
    //             "Reciting the alphabet",
    //             "Ability to say last letter of the word",
    //             "Reading 3 words that rhyme/word families (Adv.)",
    //             "Orally reading words with diphthongs and digraphs (Adv.)",
    //             "Sounding out blends in initial position of words (Adv.)",
    //             "Reading words that are irregular to English (Adv.)",
    //             "Able to sound out nonsense words with the long vowels having the final e and able to give the final e rule (Adv.)",
    //             "Able to sound out short vowel words a, e, i, o, and u using nonsense words (Adv.)"
    //         ]
    //     }
    // ];

    // const writingSkills = [
    //     {
    //         title: "Handwriting",
    //         items: [
    //             "Forming lowercase and uppercase letters correctly",
    //             "Developing fine motor skills so that they can use a range of tools competently, safely, and confidently",
    //             "Developing the foundations of a handwriting style which is fast, accurate, and efficient (Adv.)"
    //         ]
    //     },
    //     {
    //         title: "Spelling",
    //         items: [
    //             "Spelling the days of the week",
    //             "Spelling some taught common expectation, high frequency, and familiar words",
    //             "Using letter names to distinguish between alternative spellings of the same sound (Adv.)"
    //         ]
    //     },
    //     {
    //         title: "Grammatical Terminology",
    //         items: [
    //             "Knowing the meaning of \"punctuation\"",
    //             "Knowing the meaning of \"sentence\"",
    //             "Knowing the meaning of \"plural\" (Adv.)",
    //             "Knowing the meaning of \"singular\" (Adv.)"
    //         ]
    //     },
    //     {
    //         title: "Finding Mistakes",
    //         items: [
    //             "Discussing what they have written with the teachers or other pupils",
    //             "Ensuring verbs are used to indicate time correctly and consistently, including verbs in the continuous form (Adv.)",
    //             "Checking written work by reading and make changes when necessary (Adv.)"
    //         ]
    //     },
    //     {
    //         title: "Sentence Structure",
    //         items: [
    //             "Thinking of, saying, and writing a simple sentence, sometimes using a capital letter and full stop",
    //             "Organizing paragraphs around a theme (Adv.)",
    //             "Selecting appropriate grammar and vocabulary and understanding how such choices can change and enhance meaning (Adv.)",
    //             "Creating settings, characters, and plot in narratives (Adv.)"
    //         ]
    //     },
    //     {
    //         title: "Context/Content",
    //         items: [
    //             "Writing about personal experiences and those of others",
    //             "Writing about real events (Adv.)",
    //             "Writing poetry (Adv.)",
    //             "Writing for different purposes (Adv.)"
    //         ]
    //     }
    // ];

    // const receptiveLanguage = [
    //     {
    //         title: "Attention to Environment",
    //         items: ["Auditory Localization", "Attends to gestures on the screen", "Attends to gestures from caregiver"]
    //     },
    //     {
    //         title: "Auditory Perception",
    //         items: ["Attending to names", "Attending to object names", "Functional play"]
    //     },
    //     {
    //         title: "Interact with Environment",
    //         items: ["Mouths or bangs objects"]
    //     },
    //     {
    //         title: "Attention to people",
    //         items: ["Anticipation"]
    //     },
    //     {
    //         title: "Syntax",
    //         items: [
    //             "That is sleeping",
    //             "That is not black",
    //             "Understands sentences post noun elaboration - that is in the box",
    //             "Understands complex sentences with modifiers"
    //         ]
    //     },
    //     {
    //         title: "Problem Solving Skills",
    //         items: ["Attending to names", "Attending to object names", "Functional Play"]
    //     },
    //     {
    //         title: "Analogies",
    //         items: ["Sleep/sit", "Eat/cut", "Hear/see", "Idioms"]
    //     },
    //     {
    //         title: "Preposition",
    //         items: ["Spatial Concepts: under, in, back, next to, in front of"]
    //     },
    //     {
    //         title: "Pragmatics",
    //         items: ["Theory of mind - understands false beliefs"]
    //     },
    //     {
    //         title: "Inferencing",
    //         items: ["How messy", "How wet", "How tired"]
    //     },
    //     {
    //         title: "Morphologies",
    //         items: [
    //             "Not crying - negative",
    //             "No eggs",
    //             "Not in box",
    //             "Pronouns: her his, she, he, they",
    //             "Judging correct grammar"
    //         ]
    //     },
    //     {
    //         title: "Auditory Discrimination",
    //         items: ["Identifies initial sounds"]
    //     }
    // ];

    // const expressiveLanguage = [
    //     {
    //         title: "Vocal Development",
    //         items: ["Different types of vocalization", "Babbling"]
    //     },
    //     {
    //         title: "Gesture",
    //         items: ["Representational Gesture", "Vocabulary Development"]
    //     },
    //     {
    //         title: "Articulation",
    //         items: ["The ability to physically move the tongue, lips, teeth, and jaw to produce sequences of speech sounds."]
    //     },
    //     {
    //         title: "Semantics",
    //         items: [
    //             "Language",
    //             "Label items using words",
    //             "Vocabulary, Vocabulary development, and Vocabulary-connected speech",
    //             "Connected Speech",
    //             "Qualitative, Quantitative, Spatial, and Time-Sequence Concepts"
    //         ]
    //     },
    //     {
    //         title: "Language Structure",
    //         items: [
    //             "Syntax, Syntax-regular plurals, and Syntax-present progressive verbs",
    //             "Morphology"
    //         ]
    //     },
    //     {
    //         title: "Integrative Language Skills",
    //         items: [
    //             "Matching objects to descriptions",
    //             "Function of objects",
    //             "Abstract language",
    //             "Analogies",
    //             "Semantic absurdities",
    //             "Answering with questions",
    //             "Similes",
    //             "Synonyms",
    //             "Similarities"
    //         ]
    //     },
    //     {
    //         title: "Emergent Literary Skills",
    //         items: ["Letter identification", "Rhyming", "Syllables", "Repetition", "Retells story"]
    //     },
    //     {
    //         title: "Social Communication",
    //         items: [
    //             "Facial recognition",
    //             "Different types of vocalization",
    //             "Request repetition",
    //             "Play",
    //             "Pragmatics / making requests and comments",
    //             "Request assistance"
    //         ]
    //     },
    //     {
    //         title: "Morphology",
    //         items: ["Grammar"]
    //     }
    // ];

    // const technologyIntegration = [
    //     "Electromyography (EMG), Electroencephalogram (EEG), and Electrocardiogram (ECG) sensors",
    //     "Goniometer and motion analysis devices",
    //     "Pinch gauges/meters",
    //     "Dynamometers"
    // ];

    // const stats = [
    //     { value: "1B+", label: "People affected globally" },
    //     { value: "12.4M", label: "US children with learning differences" },
    //     { value: "60%", label: "Have multiple conditions" },
    // ];

    // const popupContent = {
    //     screening: {
    //         title: "Screening/Mini-Test",
    //         content: `NeuroLeap's screening module provides a quick, efficient way to identify potential learning differences
    //         and developmental delays. Our AI-powered mini-tests are designed to be engaging for children while providing
    //         clinicians with valuable preliminary data. The screening process covers multiple domains including cognitive
    //         abilities, motor skills, and language development, allowing for early identification of areas that may
    //         require further assessment or intervention.`
    //     },
    //     assessment: {
    //         title: "Assessment",
    //         content: `Our comprehensive assessment tools go beyond traditional paper-based methods to provide detailed,
    //         objective evaluations across multiple developmental domains. Using advanced sensor technology and AI analysis,
    //         NeuroLeap assessments capture nuanced data about a child's abilities in areas such as attention, memory,
    //         motor coordination, and language processing. Results are automatically correlated and presented in
    //         easy-to-understand reports, enabling clinicians to develop targeted intervention strategies.`
    //     },
    //     intervention: {
    //         title: "Intervention/Training",
    //         content: `NeuroLeap's intervention and training modules provide personalized, adaptive learning experiences
    //         tailored to each child's unique needs and abilities. Our gamified approach keeps children engaged while
    //         systematically building skills in areas of difficulty. The system continuously monitors progress and
    //         automatically adjusts difficulty levels to maintain optimal challenge. Real-time feedback helps clinicians
    //         track improvement and make data-driven decisions about treatment modifications.`
    //     }
    // };

    const renderAccordionSection = (title, icon, skills, isSimpleList = false) => (
        <Box sx={{ mb: 6 }}>
            <Typography variant="h5" sx={{ fontWeight: 600, mb: 3, display: 'flex', alignItems: 'center', gap: 1 }}>
                {icon} {title}
            </Typography>
            <Box
                sx={{
                    display: 'flex',
                    flexWrap: 'wrap',
                    gap: 2,
                    alignItems: 'flex-start',
                }}
            >
                {skills.map((skill, index) => (
                    <Box
                        key={index}
                        sx={{
                            width: {
                                xs: '100%',
                                sm: 'calc(50% - 8px)',
                                md: 'calc(33.333% - 11px)',
                            },
                        }}
                    >
                        <Accordion
                            elevation={0}
                            sx={{
                                border: '1px solid',
                                borderColor: 'grey.300',
                                borderRadius: '8px !important',
                                '&:before': { display: 'none' },
                            }}
                        >
                            <AccordionSummary expandIcon={<ExpandMoreIcon />}>
                                <Typography sx={{ fontWeight: 500 }}>{skill.title}</Typography>
                            </AccordionSummary>
                            <AccordionDetails>
                                {isSimpleList ? (
                                    <Typography variant="body2" color="text.secondary">
                                        {skill.description}
                                    </Typography>
                                ) : (
                                    <>
                                        <List dense>
                                            {skill.items && skill.items.map((item, i) => (
                                                <ListItem key={i} sx={{ py: 0.5 }}>
                                                    <ListItemIcon sx={{ minWidth: 24 }}>
                                                        <CheckCircle sx={{ fontSize: 14, color: 'success.main' }} />
                                                    </ListItemIcon>
                                                    <ListItemText
                                                        primary={item}
                                                        primaryTypographyProps={{ variant: 'body2' }}
                                                    />
                                                </ListItem>
                                            ))}
                                        </List>
                                        {skill.subSection && (
                                            <Accordion
                                                elevation={0}
                                                sx={{
                                                    mt: 1,
                                                    border: '1px solid',
                                                    borderColor: 'grey.200',
                                                    borderRadius: '4px !important',
                                                    '&:before': { display: 'none' },
                                                }}
                                            >
                                                <AccordionSummary expandIcon={<ExpandMoreIcon />}>
                                                    <Typography variant="body2" sx={{ fontWeight: 500 }}>
                                                        {skill.subSection.title}
                                                    </Typography>
                                                </AccordionSummary>
                                                <AccordionDetails>
                                                    <List dense>
                                                        {skill.subSection.items.map((subItem, si) => (
                                                            <ListItem key={si} sx={{ py: 0.25 }}>
                                                                <ListItemIcon sx={{ minWidth: 20 }}>
                                                                    <CheckCircle sx={{ fontSize: 12, color: 'primary.main' }} />
                                                                </ListItemIcon>
                                                                <ListItemText
                                                                    primary={subItem}
                                                                    primaryTypographyProps={{ variant: 'body2' }}
                                                                />
                                                            </ListItem>
                                                        ))}
                                                    </List>
                                                </AccordionDetails>
                                            </Accordion>
                                        )}
                                    </>
                                )}
                            </AccordionDetails>
                        </Accordion>
                    </Box>
                ))}
            </Box>
        </Box>
    );

    return (
        <Box>
            {/* Hero Section */}
            <Box
                sx={{
                    background: 'linear-gradient(135deg, #7B1FA2 0%, #512DA8 100%)',
                    color: 'white',
                    py: { xs: 6, md: 10 },
                    px: 2,
                }}
            >
                <Container maxWidth="lg">
                    <Grid container spacing={4} alignItems="center">
                        <Grid item xs={12} md={6}>
                            <Box sx={{ display: 'flex', alignItems: 'center', gap: 2, mb: 3 }}>
                                <Box
                                    component="img"
                                    src="NLCLogo.png"
                                    alt="NeuroLeap Logo"
                                    sx={{ height: 60 }}
                                />
                                <Box
                                    component="img"
                                    src="NLCName.png"
                                    alt="NeuroLeap"
                                    sx={{ height: 40 }}
                                />
                            </Box>
                            <Typography
                                variant="h3"
                                sx={{
                                    fontWeight: 700,
                                    fontSize: { xs: '1.75rem', md: '2.5rem' },
                                    mb: 3,
                                    lineHeight: 1.2,
                                }}
                            >
                                {t('ProductsPage.Title')}
                            </Typography>
                            <Typography
                                variant="h6"
                                sx={{ opacity: 0.9, mb: 4, fontWeight: 400, lineHeight: 1.7 }}
                            >
                               {t('ProductsPage.Subtitle')}
                            </Typography>
                            <Box sx={{ display: 'flex', gap: 2, flexWrap: 'wrap' }}>
                                <Button
                                    href="https://neuroleap.com/contact"
                                    target="_blank"
                                    variant="contained"
                                    size="large"
                                    sx={{
                                        bgcolor: 'white',
                                        color: 'primary.main',
                                        '&:hover': { bgcolor: 'rgba(255,255,255,0.9)' },
                                        px: 4,
                                        py: 1.5,
                                        borderRadius: 2,
                                    }}
                                >
                                    {t('ProductsPage.Contact Us')}
                                </Button>
                                <Button
                                    variant="outlined"
                                    size="large"
                                    component={isLoggedIn ? 'button' : Link}
                                    to={isLoggedIn ? undefined : '/login'}
                                    onClick={isLoggedIn ? () => setLearnMore(!learnMore) : undefined}
                                    sx={{
                                        borderColor: 'white',
                                        color: 'white',
                                        '&:hover': {
                                            borderColor: 'white',
                                            bgcolor: 'rgba(255,255,255,0.1)',
                                        },
                                        px: 4,
                                        py: 1.5,
                                        borderRadius: 2,
                                    }}
                                >
                                    {isLoggedIn ? (learnMore ? t('ProductsPage.Show Less') : t('ProductsPage.Learn More')) : t('ProductsPage.Login to Learn More')}
                                </Button>
                            </Box>
                        </Grid>
                        <Grid item xs={12} md={6}>
                            <Box
                                component="img"
                                src="neuro_leap_website-1.png"
                                alt="NeuroLeap Product"
                                sx={{
                                    width: '100%',
                                    borderRadius: 3,
                                    boxShadow: '0 20px 40px rgba(0,0,0,0.3)',
                                }}
                            />
                        </Grid>
                    </Grid>
                </Container>
            </Box>

            {/* Stats Section */}
            <Box sx={{ bgcolor: 'grey.900', color: 'white', py: 4 }}>
                <Container maxWidth="lg">
                    <Grid container spacing={4} justifyContent="center">
                        {stats.map((stat, index) => (
                            <Grid item xs={12} sm={4} key={index} sx={{ textAlign: 'center' }}>
                                <Typography variant="h3" sx={{ fontWeight: 700, color: 'primary.light' }}>
                                    {stat.value}
                                </Typography>
                                <Typography variant="body1" sx={{ opacity: 0.8 }}>
                                    {stat.label}
                                </Typography>
                            </Grid>
                        ))}
                    </Grid>
                </Container>
            </Box>

            {/* Features Section */}
            <Container maxWidth="lg" sx={{ py: { xs: 6, md: 10 } }}>
                <Typography variant="h4" align="center" sx={{ fontWeight: 600, mb: 2 }}>
                    {t('ProductsPage.Why Choose')}
                </Typography>
                <Divider sx={{ width: 80, mx: 'auto', mb: 6, borderColor: 'primary.main', borderWidth: 2 }} />

                <Grid container spacing={4}>
                    {featuresWithIcons.map((feature, index) => (
                        <Grid item xs={12} md={6} lg={4} key={index}>
                            <Card
                                elevation={0}
                                sx={{
                                    height: '100%',
                                    border: '1px solid',
                                    borderColor: 'grey.200',
                                    borderRadius: 3,
                                    transition: 'all 0.2s',
                                    '&:hover': {
                                        borderColor: 'primary.main',
                                        boxShadow: 3,
                                    },
                                }}
                            >
                                <CardContent sx={{ p: 3 }}>
                                    <Box sx={{ color: 'primary.main', mb: 2 }}>
                                        {feature.icon}
                                    </Box>
                                    <Typography variant="h6" sx={{ fontWeight: 600, mb: 2 }}>
                                        {feature.title}
                                    </Typography>
                                    <List dense>
                                        {feature.points.map((point, i) => (
                                            <ListItem key={i} sx={{ px: 0 }}>
                                                <ListItemIcon sx={{ minWidth: 32 }}>
                                                    <CheckCircle sx={{ fontSize: 18, color: 'success.main' }} />
                                                </ListItemIcon>
                                                <ListItemText
                                                    primary={point}
                                                    primaryTypographyProps={{
                                                        variant: 'body2',
                                                        color: 'text.secondary'
                                                    }}
                                                />
                                            </ListItem>
                                        ))}
                                    </List>
                                </CardContent>
                            </Card>
                        </Grid>
                    ))}
                </Grid>
            </Container>

            {/* Areas Covered Section */}
            <Box sx={{ bgcolor: 'grey.50', py: { xs: 6, md: 10 } }}>
                <Container maxWidth="lg">
                    <Typography variant="h4" align="center" sx={{ fontWeight: 600, mb: 2 }}>
                        {t('ProductsPage.Areas Covered')}
                    </Typography>
                    <Divider sx={{ width: 80, mx: 'auto', mb: 6, borderColor: 'primary.main', borderWidth: 2 }} />

                    <Grid container spacing={2} justifyContent="center">
                        {areasCoveredList.map((area, index) => (
                            <Grid item key={index}>
                                <Chip
                                    label={area}
                                    sx={{
                                        px: 2,
                                        py: 3,
                                        fontSize: '0.95rem',
                                        bgcolor: 'white',
                                        border: '1px solid',
                                        borderColor: 'primary.light',
                                    }}
                                />
                            </Grid>
                        ))}
                    </Grid>
                </Container>
            </Box>

            {/* Product Images Section */}
            <Container maxWidth="lg" sx={{ py: { xs: 6, md: 10 } }}>
                <Grid container spacing={4} alignItems="center">
                    <Grid item xs={12} md={6}>
                        <Box
                            component="img"
                            src="neuro_leap_website-2.png"
                            alt="NeuroLeap Interface"
                            sx={{
                                width: '100%',
                                borderRadius: 3,
                                boxShadow: 3,
                            }}
                        />
                    </Grid>
                    <Grid item xs={12} md={6}>
                        <Typography variant="h4" sx={{ fontWeight: 600, mb: 3 }}>
                            {t('ProductsPage.Multi-Symptom')}
                        </Typography>
                        <Typography variant="body1" color="text.secondary" sx={{ mb: 3, lineHeight: 1.8 }}>
                            {t('ProductsPage.MultiSymptomDesc')}
                        </Typography>
                        <List>
                            {multiSymptomPoints.map((item, index) => (
                                <ListItem key={index} sx={{ px: 0 }}>
                                    <ListItemIcon>
                                        <CheckCircle color="primary" />
                                    </ListItemIcon>
                                    <ListItemText primary={item} />
                                </ListItem>
                            ))}
                        </List>
                    </Grid>
                </Grid>
            </Container>

            {/* Addressing Critical Challenges Section */}
            <Box sx={{ bgcolor: 'grey.50', py: { xs: 6, md: 10 } }}>
                <Container maxWidth="lg">
                    <Grid container spacing={4} alignItems="center">
                        <Grid item xs={12} md={6}>
                            <Typography variant="h4" sx={{ fontWeight: 600, mb: 3 }}>
                                {t('ProductsPage.Challenges')}
                            </Typography>
                            <List>
                                {challengesPoints.map((item, index) => (
                                    <ListItem key={index} sx={{ px: 0 }}>
                                        <ListItemIcon>
                                            <CheckCircle color="primary" />
                                        </ListItemIcon>
                                        <ListItemText primary={item} />
                                    </ListItem>
                                ))}
                            </List>
                        </Grid>
                        <Grid item xs={12} md={6}>
                            <Box
                                component="img"
                                src="kayley3.png"
                                alt="Child using NeuroLeap"
                                sx={{
                                    width: '100%',
                                    borderRadius: 3,
                                    boxShadow: 3,
                                }}
                            />
                        </Grid>
                    </Grid>
                </Container>
            </Box>

            {/* Learn More Section (Logged In) */}
            {learnMore && (
                <Box sx={{ bgcolor: 'grey.100', py: { xs: 6, md: 10 } }}>
                    <Container maxWidth="lg">
                        <Typography variant="h4" align="center" sx={{ fontWeight: 600, mb: 2 }}>
                            {t('ProductsPage.Detailed Skills')}
                        </Typography>
                        <Divider sx={{ width: 80, mx: 'auto', mb: 6, borderColor: 'primary.main', borderWidth: 2 }} />

                        {/* Application Areas Buttons */}
                        <Box sx={{ mb: 6 }}>
                            <Typography variant="h5" sx={{ fontWeight: 600, mb: 3, textAlign: 'center' }}>
                                {t('ProductsPage.SomeAreasCover')}
                            </Typography>
                            <Box sx={{ display: 'flex', gap: 2, justifyContent: 'center', flexWrap: 'wrap' }}>
                                <Popup
                                    trigger={
                                        <Button variant="contained" color="secondary" sx={{ px: 3, py: 1.5 }}>
                                            {popupContent.screening?.title || "Screening/Mini-Test"}
                                        </Button>
                                    }
                                    modal
                                    contentStyle={{
                                        maxWidth: '600px',
                                        padding: '24px',
                                        borderRadius: '8px'
                                    }}
                                >
                                    <Box>
                                        <Typography variant="h5" sx={{ fontWeight: 600, mb: 2 }}>
                                            {popupContent.screening.title}
                                        </Typography>
                                        <Typography variant="body1" color="text.secondary">
                                            {popupContent.screening.content}
                                        </Typography>
                                    </Box>
                                </Popup>
                                <Popup
                                    trigger={
                                        <Button variant="contained" color="secondary" sx={{ px: 3, py: 1.5 }}>
                                            {popupContent.assessment?.title || "Assessment"}
                                        </Button>
                                    }
                                    modal
                                    contentStyle={{
                                        maxWidth: '600px',
                                        padding: '24px',
                                        borderRadius: '8px'
                                    }}
                                >
                                    <Box>
                                        <Typography variant="h5" sx={{ fontWeight: 600, mb: 2 }}>
                                            {popupContent.assessment.title}
                                        </Typography>
                                        <Typography variant="body1" color="text.secondary">
                                            {popupContent.assessment.content}
                                        </Typography>
                                    </Box>
                                </Popup>
                                <Popup
                                    trigger={
                                        <Button variant="contained" color="secondary" sx={{ px: 3, py: 1.5 }}>
                                            {popupContent.intervention?.title || "Intervention/Training"}
                                        </Button>
                                    }
                                    modal
                                    contentStyle={{
                                        maxWidth: '600px',
                                        padding: '24px',
                                        borderRadius: '8px'
                                    }}
                                >
                                    <Box>
                                        <Typography variant="h5" sx={{ fontWeight: 600, mb: 2 }}>
                                            {popupContent.intervention.title}
                                        </Typography>
                                        <Typography variant="body1" color="text.secondary">
                                            {popupContent.intervention.content}
                                        </Typography>
                                    </Box>
                                </Popup>
                            </Box>
                        </Box>

                        <Divider sx={{ my: 4 }} />

                        {/* Core Cognitive Skills */}
                        {renderAccordionSection(t('ProductsPage.Sections.CoreCognitiveSkills'), <Psychology color="primary" />, cognitiveSkills)}

                        {/* Interpersonal Skills */}
                        {renderAccordionSection(t('ProductsPage.Sections.InterpersonalSkills'), <EmojiEmotions color="primary" />, interpersonalSkills, true)}

                        {/* Identifiable Emotions */}
                        {renderAccordionSection(t('ProductsPage.Sections.IdentifiableEmotions'), <EmojiEmotions color="primary" />, identifiableEmotions, true)}

                        {/* Gross Motor Skills */}
                        {renderAccordionSection(t('ProductsPage.Sections.GrossMotor'), <DirectionsRun color="primary" />, grossMotorSkills)}

                        {/* Fine Motor Skills */}
                        {renderAccordionSection(t('ProductsPage.Sections.FineMotor'), <Create color="primary" />, fineMotorSkills)}

                        {/* Reading Skills */}
                        {renderAccordionSection(t('ProductsPage.Sections.ReadingSkills'), <MenuBook color="primary" />, readingSkills)}

                        {/* Writing Skills */}
                        {renderAccordionSection(t('ProductsPage.Sections.WritingSkills'), <Create color="primary" />, writingSkills)}

                        {/* Receptive Language */}
                        {renderAccordionSection(t('ProductsPage.Sections.ReceptiveLanguage'), <Hearing color="primary" />, receptiveLanguage)}

                        {/* Expressive Language */}
                        {renderAccordionSection(t('ProductsPage.Sections.ExpressiveLanguage'), <RecordVoiceOver color="primary" />, expressiveLanguage)}
                      
                        {/* Technology Integration */}
                        <Box sx={{ mb: 6 }}>
                            <Typography variant="h5" sx={{ fontWeight: 600, mb: 3, display: 'flex', alignItems: 'center', gap: 1 }}>
                                <Sensors color="primary" /> {t('ProductsPage.Sections.TechnologyIntegration')}
                            </Typography>
                            <Accordion
                                elevation={0}
                                sx={{
                                    border: '1px solid',
                                    borderColor: 'grey.300',
                                    borderRadius: '8px !important',
                                    '&:before': { display: 'none' },
                                }}
                            >
                                <AccordionSummary expandIcon={<ExpandMoreIcon />}>
                                    <Typography sx={{ fontWeight: 500 }}>{t('ProductsPage.Sections.TechnologyIntegration')}</Typography>
                                </AccordionSummary>
                                <AccordionDetails>
                                    <List dense>
                                        {technologyIntegration.map((item, index) => (
                                            <ListItem key={index} sx={{ py: 0.5 }}>
                                                <ListItemIcon sx={{ minWidth: 24 }}>
                                                    <CheckCircle sx={{ fontSize: 14, color: 'success.main' }} />
                                                </ListItemIcon>
                                                <ListItemText
                                                    primary={item}
                                                    primaryTypographyProps={{ variant: 'body2' }}
                                                />
                                            </ListItem>
                                        ))}
                                    </List>
                                </AccordionDetails>
                            </Accordion>
                        </Box>

                        {/* NL1 Hub App Image */}
                        <Box sx={{ textAlign: 'center', mt: 6 }}>
                            <Box
                                component="img"
                                src={NL1HubApp}
                                alt="NL1 Hub App"
                                sx={{
                                    maxWidth: '100%',
                                    borderRadius: 3,
                                    boxShadow: 3,
                                }}
                            />
                        </Box>
                    </Container>
                </Box>
            )}

            {/* CTA Section */}
            <Box
                sx={{
                    background: 'linear-gradient(135deg, #E8DEF8 0%, #F3E5F5 100%)',
                    py: { xs: 6, md: 10 },
                    px: 2,
                }}
            >
                <Container maxWidth="md">
                    <Paper
                        elevation={3}
                        sx={{
                            p: { xs: 4, md: 6 },
                            textAlign: 'center',
                            borderRadius: 4,
                        }}
                    >
                        <Typography variant="h4" sx={{ fontWeight: 600, mb: 2 }}>
                            {t('ProductsPage.Ready')}
                        </Typography>
                        <Typography
                            variant="body1"
                            color="text.secondary"
                            sx={{ mb: 4, lineHeight: 1.8, maxWidth: 600, mx: 'auto' }}
                        >
                            {t('ProductsPage.CTADesc')}
                        </Typography>
                        <Box sx={{ display: 'flex', gap: 2, justifyContent: 'center', flexWrap: 'wrap' }}>
                            <Button
                                href="https://neuroleap.com/contact"
                                target="_blank"
                                variant="contained"
                                size="large"
                                sx={{ px: 5, py: 1.5, borderRadius: 2 }}
                            >
                                {t('ProductsPage.Contact Us')}
                            </Button>
                            <Button
                                href="https://vividkids.org"
                                target="_blank"
                                variant="outlined"
                                size="large"
                                sx={{ px: 5, py: 1.5, borderRadius: 2 }}
                            >
                                {t('Visit VividKids.org')}
                            </Button>
                        </Box>
                    </Paper>
                </Container>
            </Box>
        </Box>
    );
}

export default Product;
